import { formatUserName } from '~/util/formatters';
import { enumValue } from '~/util/enums';
import { NotePCMFoc, NotePCMQuality, NotePCMRisk } from '~/components/Patient';
import React from 'react';

export function createdByUserName(reminder: ReminderType) {
    if (reminder?.notes.length === 0) return null;
    if (!reminder.notes[reminder.notes.length - 1]?.created_by_user) return null;
    return formatUserName(reminder.notes[reminder.notes.length - 1].created_by_user!);
}

export function retrievedGap(reminder: ReminderType, patient: PatientType | null) {
    if (patient) {
        if (reminder.type === enumValue(['note', 'type', 'Risk Gap Note']))
            return patient.risk_gaps.find((x) => x.id === reminder?.risk_gap?.id);
        if (reminder.type === enumValue(['note', 'type', 'FOC Gap Note']))
            return patient.foc_gaps.find((x) => x.id === reminder?.foc_gap?.id);
        if (reminder.type === enumValue(['note', 'type', 'Quality Gap Note']))
            return patient.quality_gaps.find((x) => x.id === reminder?.quality_gap?.id);
    }
    return null;
}

export function getGapNotePCM(reminder: ReminderType, patient: PatientType | null) {
    switch (reminder.type) {
        case enumValue(['note', 'type', 'Risk Gap Note']):
            return (
                <NotePCMRisk
                    patientId={reminder.patient.id}
                    entity={reminder}
                    gap={retrievedGap(reminder, patient) as RiskGapType}
                />
            );
        case enumValue(['note', 'type', 'FOC Gap Note']):
            return (
                <NotePCMFoc
                    patientId={reminder.patient.id}
                    entity={reminder}
                    gap={retrievedGap(reminder, patient) as GapType}
                />
            );
        case enumValue(['note', 'type', 'Quality Gap Note']):
            return (
                <NotePCMQuality
                    patientId={reminder.patient.id}
                    entity={reminder}
                    gap={retrievedGap(reminder, patient) as GapType}
                />
            );
        default:
            return null;
    }
}

export const reminderStatusOptions = [
    {
        value: enumValue(['task', 'status', 'Not Started']) as number,
        label: 'Open',
        noteLabel: 'open',
        description: 'Needs action now',
    },
    {
        value: enumValue(['task', 'status', 'In Progress']) as number,
        label: 'In Progress',
        noteLabel: 'in progress',
        description: 'Work is in progress',
    },
    {
        value: enumValue(['task', 'status', 'Completed']) as number,
        label: 'Done',
        noteLabel: 'done',
        description: 'Completed on time',
    },
    {
        value: enumValue(['task', 'status', 'Dismissed']) as number,
        label: 'N/A',
        noteLabel: 'N/A',
        description: 'Not applicable',
    },
    {
        value: enumValue(['task', 'status', 'Missed']) as number,
        label: 'Missed',
        noteLabel: 'missed',
        description: 'Completed past due date',
    },
];
